import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-log-visualizer-confirmation-modal',
  templateUrl: './log-visualizer-confirmation-modal.component.html',
  styleUrls: ['./log-visualizer-confirmation-modal.component.css']
})
export class LogVisualizerConfirmationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<LogVisualizerConfirmationModalComponent>) { }

  public isLoading: boolean;

  ngOnInit(): void {
    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({ viewData: false });
  }

  clickConfirm() {
    this.matDialogRef.close({ viewData: true });
  }

  clickCancel() {
    this.matDialogRef.close({ viewData: false });
  }
}
